<template>
  <div class="VideoPlayer">
    <video ref="videoPlayer" class="video-js"></video>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      player: null
    }
  },
  mounted() {
    this.initPlayer()
  },
  methods: {
    initPlayer() {
      this.player = videojs(this.$refs.videoPlayer, this.options, () => {
        this.$emit('ready')
      })
    },
    play() {
      this.player.play()
    },
    pause() {
      this.player.pause()
    }
  },
  // eslint-disable-next-line
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>

<style lang="scss" scoped>
.VideoPlayer {
  width: 100%;
  height: 100%;
}

.video-js {
  width: 100%;
  height: 100%;
  background: #000000;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 0 !important;
}
</style>
